export default __webpack_public_path__ + "static/education-4ba0043a2dea58bf888cf9aa4d629a29.png";